import { Store } from '@stores/Store'

export class BronzeConsistencyIncentiveCalculation {
  store!: Store

  constructor(store: Store) {
    this.store = store
  }

  // Bronze Consistency Incentive

  get bronzeBuilderConsitency6x(): number {
    const { store } = this
    const { countryData } = store

    return countryData.bronzeBuilderConsistency.multiplier6x!
  }

  get bronzeBuilderConsitency12x(): number {
    const { store } = this
    const { countryData } = store

    return countryData.bronzeBuilderConsistency.multiplier12x!
  }

  get bronzeBuilderConsitencyIncentiveAmount(): number {
    const { store } = this
    const { bronzeConsistencyIncentiveStore } = store
    const { bronzeConsistencyIncentiveActive, bronzeBuilderConsistency6xEnabled, bronzeBuilderConsistency12xEnabled } = bronzeConsistencyIncentiveStore

    if (!bronzeConsistencyIncentiveActive) { return 0 }

    let bronzeBuilderConsitencyIncentiveAmount = 0
    if (bronzeBuilderConsistency6xEnabled || bronzeBuilderConsistency12xEnabled) {
      if (bronzeBuilderConsistency6xEnabled) { bronzeBuilderConsitencyIncentiveAmount += this.bronzeBuilderConsitency6x }
      if (bronzeBuilderConsistency12xEnabled) { bronzeBuilderConsitencyIncentiveAmount += this.bronzeBuilderConsitency12x }
    }

    return bronzeBuilderConsitencyIncentiveAmount
  }

}
